import { Field, FieldError, FieldGroup, FieldLabel, FieldSet } from '@talentmesh/ui/components/field';
import { Textarea } from '@talentmesh/ui/components/textarea';
import { useFieldArray } from 'react-hook-form';
import { useRefineSearchCriteriaFormContext } from '../useRefineSearchCriteriaForm';
import UIStrings from '@/Utils/UIStrings';

const RankingCriteriaForm = () => {
    const form = useRefineSearchCriteriaFormContext();
    const {
        formState: { errors },
    } = form;
    const { fields } = useFieldArray({
        control: form.control,
        name: 'rankingCriteria',
    });

    return (
        <FieldGroup className="flex w-full flex-col gap-2.5 p-2.5">
            <FieldSet>
                {fields.map((field, i) => {
                    const criterionId = form.getValues(`rankingCriteria.${i}.id`);
                    return (
                        <Field key={field.id}>
                            <FieldLabel
                                htmlFor={`${criterionId}-criterion`}
                                className="text-foreground text-sm font-bold"
                            >
                                {UIStrings.Criteria(i + 1)}:
                            </FieldLabel>
                            <Textarea
                                id={`${criterionId}-criterion`}
                                defaultValue={field.criterion}
                                disabled={form.formState.disabled}
                                onChange={(e) =>
                                    form.setValue(`rankingCriteria.${i}.criterion`, e.target.value, {
                                        shouldDirty: true,
                                    })
                                }
                                rows={4}
                            />
                            <FieldError>{errors.rankingCriteria?.[i]?.criterion?.message}</FieldError>
                        </Field>
                    );
                })}
            </FieldSet>
        </FieldGroup>
    );
};

export default RankingCriteriaForm;
